import { Injectable } from '@angular/core';
import ZebraBleModeReader, { TZebraBleConnectionState } from './zebra-ble-mode-reader';
import { BehaviorSubject, Subject } from 'rxjs';
import { TScannedInfoWithScanLockDetails } from '@monorepo/types';
import { BluetoothCommonService } from '../../capacitor/bluetooth/bluetooth-common.service';
import { PluginListenerHandle } from '@capacitor/core';
import { InputAppAPIHelperUtil } from '@monorepo/utils';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class ZebraBleModeReaderService {
  private zebraBleConnectionStateEmitter = new BehaviorSubject<TZebraBleConnectionState>({
    connectionState: 'DISCONNECTED',
  });
  private zebraBleScannedBarcodeData = new Subject<TScannedInfoWithScanLockDetails>();

  private connectionListener?: PluginListenerHandle;
  private barcodeListener?: PluginListenerHandle;

  constructor(
    private bluetoothCommonService: BluetoothCommonService,
    private apiHelper: InputAppAPIHelperUtil,
    private platform: Platform,
  ) {
    void this.init();
  }

  init(): void {
    this.platform.ready().then(async () => {
      await this.startZebraBleConnectionStateListener();
      await this.startZebraBleBarcodeScanDataListener();
    });
  }

  async setZebraEnabled(enabled: boolean) {
    await ZebraBleModeReader.setZebraEnabled({ enabled });
  }

  getZebraBleConnectionStateEmitterSubscription() {
    return this.zebraBleConnectionStateEmitter.asObservable();
  }

  getZebraBleScannedDataSubscription() {
    return this.zebraBleScannedBarcodeData.asObservable();
  }

  async showConnectDeviceBarcode(): Promise<void> {
    try {
      await ZebraBleModeReader.showConnectDeviceBarcode();
    } catch (err) {
      console.log({ err });
      this.apiHelper.showPopup(
        'Error',
        (err as { message: string | undefined }).message ??
          'Unable to generate pairing barcode, please contact support',
      );
    }
  }

  async disconnectZebraBleModeDevice(): Promise<void> {
    await ZebraBleModeReader.disconnectScanner();
  }

  private async startZebraBleConnectionStateListener() {
    console.log('connectionUpdateListener called');
    if (this.connectionListener) return;
    this.connectionListener = await ZebraBleModeReader.addListener(
      'connectionUpdateListener',
      (info: TZebraBleConnectionState) => {
        this.zebraBleConnectionStateEmitter.next(info);
      },
    );
  }

  private async startZebraBleBarcodeScanDataListener() {
    console.log('onBarcodeScanned called');
    if (this.barcodeListener) return;
    this.barcodeListener = await ZebraBleModeReader.addListener('onBarcodeScanned', (info: { data: string }) => {
      console.log({ barcode: info.data });
      this.zebraBleScannedBarcodeData.next({
        byteString: info.data,
        lockDetails: this.bluetoothCommonService.getScanLockDetails(),
      });
    });
  }
}
